import { render, staticRenderFns } from "./InstaFeedComponent.vue?vue&type=template&id=4c348e04&scoped=true&"
import script from "./InstaFeedComponent.vue?vue&type=script&lang=js&"
export * from "./InstaFeedComponent.vue?vue&type=script&lang=js&"
import style0 from "./InstaFeedComponent.vue?vue&type=style&index=0&id=4c348e04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c348e04",
  null
  
)

export default component.exports